var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackspace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "70px",
    height: "70px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M490.667 64h-357.59a21.333 21.333 0 0 0-17.848 9.647L3.485 244.314a21.334 21.334 0 0 0 0 23.372l111.744 170.667A21.333 21.333 0 0 0 133.077 448h357.589c11.782 0 21.333-9.551 21.333-21.333V85.333C512 73.551 502.449 64 490.667 64zm-21.334 341.333H144.609L46.833 256l97.776-149.333h324.725v298.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.246 356.418c8.331 8.331 21.839 8.331 30.17 0l70.248-70.248 70.248 70.248c8.331 8.331 21.839 8.331 30.17 0s8.331-21.839 0-30.17L328.834 256l70.248-70.248c8.331-8.331 8.331-21.839 0-30.17s-21.839-8.331-30.17 0l-70.248 70.248-70.248-70.248c-8.331-8.331-21.839-8.331-30.17 0-8.331 8.331-8.331 21.839 0 30.17L268.495 256l-70.248 70.248c-8.332 8.332-8.332 21.839-.001 30.17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.e4bf5a084de7109032a7da7cde7b58a4.svg";
export { ForwardRef as ReactComponent };